import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#222222] text-slate-200 mt-16 border-t border-neutral-800">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        
        {/* Primary Row Content */}
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3 pb-10 border-b border-neutral-800">
          
          {/* Left Block */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img src="/images/survey.jpg" alt="Survey icon" className="object-cover w-12 h-12 rounded-full border border-neutral-700"/>
              <div>
                <h3 className="text-xl font-bold text-amber-500 tracking-tight">New World Surveyor</h3>
                <span className="text-xs text-neutral-400">Build And Measure Your Land With Us</span>
              </div>
            </div>

            <div className="space-y-3 text-sm text-neutral-300">
              <div className="flex items-start gap-2.5">
                <img src="/images/phone.png" className="w-4 h-4 mt-0.5 filter opacity-80" alt="Phone icon" />
                <p><span className="text-neutral-400">Phone:</span> 0791857693</p>
              </div>
              <div className="flex items-start gap-2.5">
                <img src="/images/email.png" className="w-4 h-4 mt-0.5 filter opacity-80" alt="Email icon" />
                <p className="break-all"><span className="text-neutral-400">Email:</span> newsurveyor123@gmail.com</p>
              </div>
              <div className="flex items-start gap-2.5">
                <img src="/images/location.png" className="w-4 h-4 mt-0.5 filter opacity-80" alt="Location icon" />
                <p><span className="text-neutral-400">Location:</span> Kigali, Rwanda</p>
              </div>
              <div className="flex items-start gap-2.5">
                <img src="/images/hour.png" className="w-4 h-4 mt-0.5 filter opacity-80" alt="Working Hour icon" />
                <p><span className="text-neutral-400">Hours:</span> Mon-Fri 9Am-5Pm , Sat 10Am-3Pm</p>
              </div>
            </div>
          </div>

          {/* Middle Block */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/images/service.png" alt="Service icon" className="object-cover w-8 h-8 rounded-full filter opacity-90"/>
              <p className="text-lg font-bold tracking-tight text-white">Our Services</p>
            </div>
            <ul className="pl-4 space-y-2 text-sm text-neutral-400 border-l-2 border-amber-500">
              <li>Making Land Boundary</li>
              <li>Measuring Land Size</li>
              <li>Drawing Land Maps</li>
              <li>Helping With Construction</li>
            </ul>
          </div>

          {/* Right Block */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/images/contractor.png" alt="Company icon" className="object-cover w-8 h-8 rounded-full filter opacity-90"/>
              <p className="text-lg font-bold tracking-tight text-white">Our Company</p>
            </div>
            <ul className="pl-4 space-y-2 text-sm border-l-2 border-blue-500">
              <li>
                <Link to="/privacy" className="text-neutral-400 hover:text-amber-500 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-neutral-400 hover:text-amber-500 transition-colors">
                  Partner
                </Link>
              </li>
              <li>
                <Link to="/Landing" className="text-neutral-400 hover:text-amber-500 transition-colors">
                  All Services
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-neutral-400 hover:text-amber-500 transition-colors">
                  Help
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Matrix */}
        <div className="py-6 flex flex-col items-center justify-between gap-4 sm:flex-row border-b border-neutral-800">
          <p className="text-sm font-semibold tracking-wider text-neutral-400 uppercase">Follow Us On:</p>
          <div className="flex items-center gap-5">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <img src="/images/facebook.png" alt="Facebook" className="w-7 h-7 hover:scale-110 transition-transform"/>
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <img src="/images/instagram.png" alt="Instagram" className="w-7 h-7 hover:scale-110 transition-transform"/>
            </a>
            <a href="https://web.whatsapp.com" target="_blank" rel="noopener noreferrer">
              <img src="/images/whatsapp.png" alt="Whatsapp" className="w-7 h-7 hover:scale-110 transition-transform"/>
            </a>
            <a href="https://www.messenger.com" target="_blank" rel="noopener noreferrer">
              <img src="/images/messanger.png" alt="Messenger" className="w-7 h-7 hover:scale-110 transition-transform"/>
            </a>
          </div>
        </div>

        {/* Legal Copyright Section */}
        <div className="pt-6 flex flex-col items-center justify-between gap-4 text-xs text-neutral-500 sm:flex-row">
          <div className="flex items-center gap-2 text-center sm:text-left">
            <img src="/images/reseved.png" alt="Reserved" className="w-5 h-5 opacity-40" />
            <p>© 2026 <span className="text-neutral-400 font-medium">New World Surveyor</span>. All Rights Reserved.</p>
          </div>
          <div className="text-center sm:text-right text-neutral-500">
            <p>Professional In Land Survey • Developed By <span className="text-neutral-400 font-medium">AphroWebStack</span></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;